import React, {SVGProps} from "react";

const IconClose = (props: SVGProps<SVGSVGElement>) => {
    const {color = "#404446", width = "24", height = "25", ...rest} = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 25"
            fill="none"
            {...rest}
        >
            <path d="M5 5.25L19 19.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M19 5.25L5 19.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
};

export default IconClose;
